import { Icon, Modal } from 'Components';
import styles from './UInassignTrainingModal.module.scss';
import Button from '../Button';

interface UnassignTrainingModalProps {
	visible: boolean;
	onSubmit: () => void;
	onCancel: () => void;
	// bulk assignment mode
	assignmentCount?: number;
	learnerCount?: number;
	// course mode
	courseCount?: number;
}
const UnassignTrainingModal: React.FC<UnassignTrainingModalProps> = ({
	visible,
	onSubmit,
	onCancel,
	assignmentCount,
	learnerCount,
	courseCount
}) => {
	const isBulk = assignmentCount !== undefined;
	const isCourse = courseCount !== undefined;

	return (
		<Modal
			visible={visible}
			onCancel={onCancel}
			className={styles.unassignModalRoot}
			footer={
				<div className={styles.unassignModal__actions}>
					<Button
						variant="borderless"
						size="small"
						onClick={onCancel}
					>
						Cancel
					</Button>
					<Button size="small" onClick={onSubmit}>
						Unassign
					</Button>
				</div>
			}
			centered
			size="xs"
		>
			<div className={styles.unassignModal}>
				<div className={styles.unassignModal__title}>
					{isCourse ? 'Unassign courses?' : 'Unassign training?'}
				</div>

				{isCourse ? (
					<div className={styles.unassignModal__wrapper}>
						<div className={styles.unassignModal__description}>
							Unassigning this course will:
						</div>
						<ul className={styles.unassignModal__list}>
							<li>Remove {courseCount} course{courseCount !== 1 ? 's' : ''}</li>
							{learnerCount !== undefined && (
								<li>Affect {learnerCount} learners total</li>
							)}
						</ul>
					</div>
				) : isBulk ? (
					<div className={styles.unassignModal__wrapper}>
						<div className={styles.unassignModal__description}>
							Unassigning this training will:
						</div>
						<ul className={styles.unassignModal__list}>
							<li>Remove {assignmentCount} assignment{assignmentCount !== 1 ? 's' : ''}</li>
							{learnerCount !== undefined && (
								<li>Affect {learnerCount} learners total</li>
							)}
						</ul>
					</div>
				) : (
					<div className={styles.unassignModal__wrapper}>
						<div className={styles.unassignModal__description}>
							This training is currently assigned, but no learners
							have started it yet.
						</div>
						<div className={styles.unassignModal__description}>
							Unassigning will remove this training from all assigned
							learners. No progress, completions, or scores will be
							affected.
						</div>
					</div>
				)}

				<div className={styles.unassignModal__warning}>
					<Icon type="warningFilledIcon" role="img" />
					This action is permanent and cannot be undone
				</div>
			</div>
		</Modal>
	);
};

export default UnassignTrainingModal;
